import { Step, StepIconProps, StepLabel, Stepper } from "@material-ui/core"
import { Box, Typography } from "components"
import { EnumClaimRequestStatus } from "constants/enums/claim-request-status"
import styled from "styled-components/macro"
import { AppColor } from "theme/app-color"
import { Icon } from "components"

const CustomStepper = styled(Stepper)<{ claimstatus: EnumClaimRequestStatus }>`
  .MuiStepConnector-root.MuiStepConnector-vertical {
    margin-left: 6px;
    padding: 0px;
  }
  .MuiStepConnector-lineVertical {
    min-height: 26px;
    margin-top: -9px;
    margin-bottom: -9px;
    width: 1px;
  }
`

const CustomStepLabel = styled(StepLabel)`
  .MuiStepIcon-root {
    font-size: 14px;
  }
`

const MappingStatusLabel = (status: EnumClaimRequestStatus) => {
  switch (status) {
    case EnumClaimRequestStatus.DRAFT:
      return "แบบร่าง"
    case EnumClaimRequestStatus.APPROVED:
      return "อนุมัติแล้ว"
    case EnumClaimRequestStatus.WAITING:
      return "รออนุมัติ"
    case EnumClaimRequestStatus.REJECTED:
      return "ไม่อนุมัติ"
    case EnumClaimRequestStatus.CANCELED:
      return "ยกเลิก"
    default:
      break
  }
}

const StatusStepIconRoot = styled("div")<{
  ownerState: { completed?: boolean; active?: boolean; error?: boolean }
}>(({ ownerState }) => ({
  backgroundColor: AppColor["Warning"],
  zIndex: 1,
  color: AppColor["White / White"],
  width: 14,
  height: 14,
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  border: `1px solid ${AppColor["White / White"]}`,
  alignItems: "center",
  ...(ownerState.active && {
    background: AppColor["Warning"],
  }),
  ...(ownerState.completed && {
    background: AppColor["Success"],
  }),
  ...(ownerState.error && {
    background: AppColor["Error/Error Text"],
  }),
}))

const StatusNoIcon = styled.div<{ bgColor: string }>`
  z-index: 1;
  height: 14px;
  width: 14px;
  background-color: ${(props) => props.bgColor};
  border-radius: 50%;
  border: 1px solid ${AppColor["White / White"]};
`

function StatusStepIcon(props: any) {
  const { active, completed, error } = props

  if (error && completed) {
    return <StatusNoIcon bgColor={AppColor["Other/Danger"]} />
  }

  if (error) {
    return <StatusNoIcon bgColor={AppColor["Other/Danger"]} />
  }

  if (active) {
    return <StatusNoIcon bgColor={AppColor["Error/Error Text"]} />
  }

  if (completed) {
    return <StatusNoIcon bgColor={AppColor["Success"]} />
  }
  return <StatusNoIcon bgColor={AppColor["Text/Gray Success"]} />
  // return <StatusStepIconRoot ownerState={{ completed, active, error }} className={className}></StatusStepIconRoot>
}

interface StepStatusProps {
  claimStatus: EnumClaimRequestStatus
  workflows: []
  workflowStep: number
  canceled?: string
}

export const StepStatus = (props: StepStatusProps) => {
  const { workflowStep, claimStatus, workflows, canceled } = props
  const labelProps: {
    optional?: React.ReactNode
    active?: boolean
    error?: boolean
    completed?: boolean
  } = { active: false, error: true, completed: true }
  return (
    <>
      {claimStatus === EnumClaimRequestStatus.CANCELED ? (
        <CustomStepper
          activeStep={workflowStep}
          orientation="vertical"
          style={{ padding: 0, background: "none" }}
          claimstatus={claimStatus}
        >
          <Step>
            <CustomStepLabel {...labelProps} StepIconComponent={StatusStepIcon}>
              <Box display="flex" alignItems="center">
                <Box minWidth="80px" mr="8px">
                  <Typography color="White / White" variant="body1">
                    ยกเลิก
                  </Typography>
                </Box>
                <Typography color="White / White" variant="subtitle1">
                  ({canceled})
                </Typography>
              </Box>
            </CustomStepLabel>
          </Step>
        </CustomStepper>
      ) : (
        <CustomStepper
          activeStep={workflowStep}
          orientation="vertical"
          style={{ padding: 0, background: "none" }}
          claimstatus={claimStatus}
        >
          {workflows.map((flow: any, index: number) => {
            const labelProps: {
              optional?: React.ReactNode
              active?: boolean
              error?: boolean
              completed?: boolean
            } = {}
            if (flow.status === EnumClaimRequestStatus.REJECTED || flow.status === EnumClaimRequestStatus.CANCELED)
              labelProps.error = true
            if (flow.status === EnumClaimRequestStatus.WAITING) labelProps.active = true
            if (claimStatus === EnumClaimRequestStatus.REJECTED && flow.status === EnumClaimRequestStatus.WAITING) {
              labelProps.active = false
              labelProps.error = false
              labelProps.completed = false
            }
            return (
              <Step key={flow.seq}>
                <CustomStepLabel {...labelProps} StepIconComponent={StatusStepIcon}>
                  <Box display="flex" alignItems="center">
                    <Box minWidth="80px" mr="8px">
                      <Typography color="White / White" variant="body1">
                        {claimStatus === EnumClaimRequestStatus.REJECTED &&
                        flow.status === EnumClaimRequestStatus.WAITING
                          ? "-"
                          : MappingStatusLabel(flow.status)}
                      </Typography>
                    </Box>
                    <Typography color="White / White" variant="subtitle1">
                      ({flow.approverTxt})
                    </Typography>
                  </Box>
                </CustomStepLabel>
              </Step>
            )
          })}
        </CustomStepper>
      )}
    </>
  )
}
